module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-8-245e9c9d07542e43f3af23340ec19a06.jpg";